__turbopack_context__.v({
  "PageCardList__Item": "DRlzSW_PageCardList__Item",
  "PageCardList__List": "DRlzSW_PageCardList__List",
});
